import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient } from "../config/base";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../config/baseWithToken";

export const signUp = createAsyncThunk(
  "auth/signup",
  async (user, thunkAPI) => {
    try {
      let { data } = await axiosClient.post("/auth/signup-with-shopify", user);
      // toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const login = createAsyncThunk("auth/login", async (user, thunkAPI) => {
  try {
    let { data } = await axiosClient.post("/auth/login", user);
    toast.success(data.message, {
      autoClose: 2000,
    });
    localStorage.setItem("loggedUser", JSON.stringify(data));
    return data;
  } catch (e) {
    toast.error(e.response.data.message);
    thunkAPI.rejectWithValue(e.response.data);
  }
});

export const forgotPassword = createAsyncThunk(
  "auth/forgot-password",
  async (user, thunkAPI) => {
    try {
      let { data } = await axiosClient.post("/auth/forgot-password", user);
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  async (resetInfo, thunkAPI) => {
    try {
      let { data } = await axiosClient.post(
        `/auth/reset-password?token=${resetInfo.token}`,
        resetInfo.password
      );
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const verifyEmail = createAsyncThunk(
  "auth/verify-email",
  async (token, thunkAPI) => {
    try {
      let { data } = await axiosClient.post(
        `/auth/verify-email?token=${token}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateUser = createAsyncThunk(
  "/admin/users",
  async (user, thunkAPI) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/users/${user?.userId}`,
        user.userDetails
      );
      // toast.success(data.message)
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "/store/user-profile",
  async (user, thunkAPI) => {
    try {
      let { data } = await axiosProtected.put(
        `/store/users/${user?.userId}`,
        user.userDetails
      );
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateShopifyAppUser = createAsyncThunk(
  "/shopify/app/user",
  async (userDetails, thunkAPI) => {
    try {
      let { data } = await axiosProtected.post(
        `/auth/update-shopify-app-user`,
        userDetails
      );
      localStorage.setItem("loggedUser", JSON.stringify(data));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const verifyStoreUser = createAsyncThunk(
  "auth/verify-store-user",
  async (userInfo, thunkAPI) => {
    try {
      let { data } = await axiosClient.post(
        `/auth/verify-store-user?token=${userInfo.token}`,
        userInfo.updatePayload
      );
      localStorage.setItem("loggedUser", JSON.stringify(data));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (Tokens, thunkAPI) => {
    try {
      const rfToken = {
        refreshToken: Tokens.refresh.token,
      };
      let { data } = await axiosClient.post("/auth/logout", rfToken);
      return data;
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
